export const GAME_MODES = {
    DAILY: 'daily',
    PRACTICE: 'practice',
};

export const MAX_ATTEMPTS = 5;

export const STORAGE_KEYS = {
    CURRENT_SCORE: 'currentScore',
    HIGH_SCORE: 'highScore',
    STREAK: 'streak',
    LIFETIME_HINTS: 'lifetimeHintsUsed',
    LAST_PLAYED: 'lastPlayed',
    GAME_STATE: 'gameState',
    THEME: 'theme',
    FIRST_TIME: 'firstTime',
    PRACTICE_GAME_ORDER: 'practiceGameOrder',
    PRACTICE_GAME_INDEX: 'practiceGameIndex',
};

export const THEMES = {
    DARK: 'dark',
    LIGHT: 'light',
};

export const MESSAGE_TYPES = {
    SUCCESS: 'success',
    ERROR: 'error',
    INFO: 'info',
    WARNING: 'warning',
};
